import { Injectable } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef
} from '@angular/material/legacy-dialog';

import { AsyncSubject, Observable } from 'rxjs';

import { LoaderService } from '@sd-portal/shared/shell';
import {
  ConfirmationDialogComponent,
  ConfirmationDialogData
} from '../components/confirmation-dialog/confirmation-dialog.component';
import { ICanDeactivateBase } from './can-deactivate.base';

@Injectable()
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class CanDeactivateGuard {
  constructor(private readonly loaderService: LoaderService, private readonly dialog: MatDialog) {}

  canDeactivate(component: ICanDeactivateBase): Observable<boolean> | Promise<boolean> | boolean {
    const shouldRoute = new AsyncSubject<boolean>();
    component.canDeactivate().subscribe(shouldAutoDeactivate => {
      if (!shouldAutoDeactivate) {
        const confirmDialog = this.initConfirmationDialog();

        confirmDialog.afterOpened().subscribe(() => this.loaderService.hideGlobalLoader());

        confirmDialog.afterClosed().subscribe(res => {
          this.loaderService.showGlobalLoader(true);
          shouldRoute.next(res);
          shouldRoute.complete();
        });
      } else {
        shouldRoute.next(true);
        shouldRoute.complete();
      }
    });
    return shouldRoute.asObservable();
  }

  private initConfirmationDialog(): MatDialogRef<ConfirmationDialogComponent> {
    const dialogData = Object.assign(new ConfirmationDialogData(), {
      header: 'You have unsaved changes!',
      message:
        'Navigating away from this screen without saving will cause your changes to be lost.',
      confirmActionText: 'Continue',
      confirmButtonColor: 'warn'
    });
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData,
      disableClose: true
    });

    return confirmDialog;
  }
}
